import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/appLayout/layout";
import { HomePage } from "./pages/homePage";
import { DetailsProduct } from "./pages/detailsPage";
import { ContactPage } from "./pages/contact";
import { LoginPage } from "./pages/login";
import { RegisterPage } from "./pages/register";
import { ForgotPasswordPage } from "./pages/forgot-password";
import { AuthProvider } from "./adminCompenents/authProvider";

import PublicRoute from "./adminCompenents/PublicRoute";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Login from "./pages/adminPage/loginPage";
import TwoStepVerification from "./pages/adminPage/verificationPage";
import { Dashboard } from "./pages/adminPage/dashbord";
import ProtectedRoute from "./adminCompenents/protectedRoute";
import AppLayout from "./adminCompenents/appLayout/layout";
import ProductsPage from "./pages/adminPage/productPage";
import UsersPage from "./pages/adminPage/usersPage";
import CategoryPage from "./pages/adminPage/categoryPage";
import AddProduct from "./pages/adminPage/addProduct";
import EditProduct from "./pages/adminPage/editProduct";
import ContactsPages from "./pages/adminPage/contactsPage";
import NewslettersPages from "./pages/adminPage/newslettersPage";
import { CartProvider } from "./context/CartContext";
import { ClientAuthProvider } from "./context/ClientAuthContext";
import Cart from "./components/Cart";
import AllProductsPage from "./pages/allProducts";
import CartPage from "./pages/adminPage/CartPage";
import ImageCategoryPage from "./pages/adminPage/ImageCategoryPage";
import PromoPage from "./pages/adminPage/promoPage";
import LoginSection from "./components/LoginSectionCart";
import ProfilePage from "./pages/profile";
import OrdersPage from "./pages/orders";
import BillingAddressForm from "./pages/BillingAddressPage";
import Checkout from "./pages/Checkout";
import AdminOrdersPage from "./pages/adminPage/OrdersPage";
import OrderDetailsPage from "./pages/adminPage/OrderDetailsPage";
import WishlistPage from "./pages/wishlistPage";
function App() {
  return (
    <>
      {" "}
      <CartProvider>
        <AuthProvider>
          <Router>
            <ToastContainer />
            <Routes>
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                }
              />
              <Route
                path="/verify-code"
                element={
                  <PublicRoute>
                    <TwoStepVerification />
                  </PublicRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <Dashboard />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/products"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <ProductsPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/category"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <CategoryPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/image-category"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <ImageCategoryPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/promo"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <PromoPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <OrdersPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/details-order/:id"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <OrderDetailsPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/add-product"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <AddProduct />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/edit-product/:id"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <EditProduct />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      {" "}
                      <UsersPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/contacts"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <ContactsPages />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/newsletters"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <NewslettersPages />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />{" "}
            </Routes>
          </Router>
        </AuthProvider>

        <ClientAuthProvider>
          <Router>
            <Routes>
              <Route
                path="/"
                element={
                  <Layout>
                    <HomePage />
                  </Layout>
                }
              />
              <Route
                path="/contact"
                element={
                  <Layout>
                    <ContactPage />
                  </Layout>
                }
              />
              <Route
                path="/details-product/:id"
                element={
                  <Layout>
                    <DetailsProduct />
                  </Layout>
                }
              />
              <Route
                path="/cart"
                element={
                  <Layout>
                    <Cart />
                  </Layout>
                }
              />
              <Route
                path="/all-products"
                element={
                  <Layout>
                    <AllProductsPage />
                  </Layout>
                }
              />

              <Route
                path="/cart-page"
                element={
                  <Layout>
                    <CartPage />
                  </Layout>
                }
              />
              <Route
                path="/wishlist"
                element={
                  <Layout>
                    {" "}
                    <WishlistPage />
                  </Layout>
                }
              />
              <Route
                path="/login-cart-page"
                element={
                  <Layout>
                    <LoginSection />
                  </Layout>
                }
              />
              <Route
                path="/payment"
                element={
                  <Layout>
                    <BillingAddressForm />
                  </Layout>
                }
              />
              <Route
                path="/livraison"
                element={
                  <Layout>
                    <Checkout />
                  </Layout>
                }
              />
              <Route path="/login-page" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/orders" element={<OrdersPage />} />
            </Routes>
          </Router>
        </ClientAuthProvider>
      </CartProvider>
    </>
  );
}

export default App;
